import { jsx as c } from "react/jsx-runtime";
import n from "react";
const u = n.createContext(void 0);
function i(e, t) {
  const o = e.getAttribute("target");
  return (!o || o === "_self") && e.origin === window.location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function a({ navigate: e, children: t }) {
  const o = n.useMemo(
    () => ({
      open: (r) => {
        i(r.currentTarget, r) && (r.preventDefault(), e(r.currentTarget.href));
      }
    }),
    [e]
  );
  return /* @__PURE__ */ c(u.Provider, { value: o, children: t });
}
a.displayName = "RouterProvider";
function l() {
  return n.useContext(u);
}
function d(e) {
  const t = l();
  if (t != null && t.open) {
    const { onClick: o } = e;
    e.onClick = (r) => {
      o && o(r), t.open(r);
    };
  }
}
export {
  a as RouterProvider,
  l as useRouter,
  d as useRouterMutateOnClick
};
//# sourceMappingURL=router-provider.js.map
